export default {
    /* Dates */
    HIGHLEVEL_SET_DATES: 'HIGHLEVEL_SET_DATES',
    HIGHLEVEL_RESET_DATES: 'HIGHLEVEL_RESET_DATES',
    HIGHLEVEL_CLEAR_DATES: 'HIGHLEVEL_CLEAR_DATES',
    /* Costs */
    HIGHLEVEL_COSTS_REQUEST: 'HIGHLEVEL_COSTS_REQUEST',
    HIGHLEVEL_COSTS_SUCCESS: 'HIGHLEVEL_COSTS_SUCCESS',
    HIGHLEVEL_COSTS_ERROR: 'HIGHLEVEL_COSTS_ERROR',
    /* Events */
    HIGHLEVEL_EVENTS_REQUEST: 'HIGHLEVEL_EVENTS_REQUEST',
    HIGHLEVEL_EVENTS_SUCCESS: 'HIGHLEVEL_EVENTS_SUCCESS',
    HIGHLEVEL_EVENTS_ERROR: 'HIGHLEVEL_EVENTS_ERROR',
    /* Unused EC2 */
    HIGHLEVEL_UNUSED_EC2_REQUEST: 'HIGHLEVEL_UNUSED_EC2_REQUEST',
    HIGHLEVEL_UNUSED_EC2_SUCCESS: 'HIGHLEVEL_UNUSED_EC2_SUCCESS',
    HIGHLEVEL_UNUSED_EC2_ERROR: 'HIGHLEVEL_UNUSED_EC2_ERROR',
    /* Tags */
    HIGHLEVEL_TAGS_KEYS_REQUEST: 'HIGHLEVEL_TAGS_KEYS_REQUEST',
    HIGHLEVEL_TAGS_KEYS_SUCCESS: 'HIGHLEVEL_TAGS_KEYS_SUCCESS',
    HIGHLEVEL_TAGS_KEYS_ERROR: 'HIGHLEVEL_TAGS_KEYS_ERROR',
    HIGHLEVEL_TAGS_KEYS_SELECT: 'HIGHLEVEL_TAGS_KEYS_SELECT',
    HIGHLEVEL_TAGS_KEYS_CLEAR_SELECTED: 'HIGHLEVEL_TAGS_KEYS_CLEAR_SELECTED',
    HIGHLEVEL_TAGS_COST_REQUEST: 'HIGHLEVEL_TAGS_COST_REQUEST',
    HIGHLEVEL_TAGS_COST_SUCCESS: 'HIGHLEVEL_TAGS_COST_SUCCESS',
    HIGHLEVEL_TAGS_COST_ERROR: 'HIGHLEVEL_TAGS_COST_ERROR',
    HIGHLEVEL_TAGS_COST_CLEAR: 'HIGHLEVEL_TAGS_COST_CLEAR',
  };
  


// WEBPACK FOOTER //
// ./src/constants/highlevel/highlevelTypes.js